'use client';

// Klaviyo's onsite script drains `window._klOnsite` when it finishes loading,
// so pushing before it is ready is safe — the command is queued rather than
// lost. That is why there is no readiness check here.
//
// A form that is not published behaves exactly like an unknown id: the command
// is consumed, no event fires and nothing renders. There is no error to catch,
// so a silent no-op here means the form is in draft, not that the call failed.
export const OpenKlaviyoForm = (formId) => {
  if (!formId || typeof window === 'undefined') return;

  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
};

// BL-395: the offer modal behind the utility bar button, the buy box promo
// pill and the sticky price bar. One form for all three, as on helix-web
// (Uma's "View Offer Overlay" form, per the ticket on 6 Oct). The id is not
// in the CMS yet, so it comes from an env var until a field is added to the
// utility_nav content type.
export const openOfferModal = () =>
  OpenKlaviyoForm(process.env.NEXT_PUBLIC_KLAVIYO_FORM_ID);
